var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKidoI(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 159,
    viewBox: "0 0 113 159",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.3688 26.5213C75.4931 19.3907 71.471 12.5706 65.242 8.08462C59.0125 3.59914 50.8503 0.711002 43.2099 0.268844C35.5689 -0.173034 27.7072 1.71288 21.0371 5.45239C14.3676 9.19168 9.14916 15.5524 5.53027 22.3072C1.91138 29.0619 0.286695 36.7194 0.84709 44.3832C1.40693 52.0472 4.78377 58.8851 7.55063 65.7333C10.5603 73.1824 10.6692 73.4519 13.2815 79.9177C16.267 87.3071 12.9089 78.9937 16.267 87.3071L18.8781 93.7734C21.6065 100.522 21.9524 101.386 25.4539 110.049C28.955 118.713 31.3676 127.166 35.9925 136.131C40.6172 145.096 48.4024 152.017 57.823 155.54C67.2429 159.062 77.6199 158.932 86.9215 155.174C96.2224 151.416 103.778 144.301 108.108 135.224C112.437 126.146 113.229 115.759 110.328 106.098C107.428 96.4362 103.38 88.9015 99.79 80.0153C96.1998 71.1291 95.0802 68.3581 92.4678 61.8923L90.6019 57.2739C87.9895 50.8081 88.2609 51.0049 85.5421 44.2757C81.9166 35.3023 81.8998 35.2735 78.3688 26.5213Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKidoI);
export default __webpack_public_path__ + "static/media/kido_i.237b7831da1897b1129dda337d57a63c.svg";
export { ForwardRef as ReactComponent };